import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

function _callSuper2(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }

  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}

import { Component } from 'react';
import Screens from '..';
import buyClickedHandler from '../Shop/buyClickedHandler';
import QueryParamsProxy from '../../utils/queryParamProxy';
import routeParamConstants, { ShopTypes } from '../../utils/routeParamConstants';
import Logger from '../../lib/analytics/logger';
import { EVENT_TYPES } from '../../lib/analytics/constants';
import audio from '../../utils/audio';
import Utils from '../../utils';
import ENVIRONMENT_VARIABLES from '../../utils/environmentVariables';
import { getText, TEXT_KEY } from '../../utils/localization';
import { purchaseActionTriggers } from '../../constants/userActions';

var formatter = require('format-number');

var format = formatter({
  prefix: '',
  suffix: '',
  truncate: 0
});

var OutOfCoin = /*#__PURE__*/function (_Component) {
  function OutOfCoin() {
    var _this2;

    _classCallCheck(this, OutOfCoin);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this2 = _callSuper2(this, OutOfCoin, [].concat(args));
    _this2.quickBuyOfferDetails = {};

    _this2._quickBuyHandler = function (sku, name) {
      audio.onClick();
      var _this2$props = _this2.props,
          outOfCoinsOffer = _this2$props.outOfCoinsOffer,
          assignTransationUUID = _this2$props.assignTransationUUID,
          gameInfo = _this2$props.gameInfo;
      sku = _this2._getSKUBasedOnPlatform(outOfCoinsOffer);
      name = outOfCoinsOffer.NAME;

      _this2.props.isOutOfCoinsPurchase(true);

      _this2.props.dismissModal();

      _this2.buyServerHandler = buyClickedHandler.bind(_this2);

      _this2.buyServerHandler(sku, name, '');

      var platform = Utils.getPlatform();
      var store;

      switch (platform) {
        case 'web':
          store = 'cams';
          break;

        case 'ios':
          store = 'appstore';
          break;

        default:
          store = platform;
      }

      var id = Logger.generateUUID();
      assignTransationUUID(id);
      Logger.setActionTrigger(purchaseActionTriggers.OUT_OF_COINS_BUY_BUTTON);
      var eventPayload = {
        type: 'regular',
        product_id: sku.toString(),
        currency: 'usd',
        store: store,
        balance_before: _this2.props.coin.toString(),
        is_test: ENVIRONMENT_VARIABLES.ENVIRONMENT !== 'PROD' ? 1 : 0,
        amount: _this2.props.outOfCoinsOffer.PRICE,
        id: id,
        trigger: purchaseActionTriggers.OUT_OF_COINS_BUY_BUTTON,
        game_provider: gameInfo.gameProvider,
        game_id: gameInfo.gameId
      };
      Logger.sendEvent(EVENT_TYPES.TRANSACTION_INITIATED, eventPayload);
    };

    _this2._visitStoreHandler = function () {
      var _QueryParamsProxy$set;

      audio.onClick();

      _this2.props.dismissModal();

      QueryParamsProxy.setQueryParams((_QueryParamsProxy$set = {}, _defineProperty(_QueryParamsProxy$set, routeParamConstants.PARAM_MODAL, Screens.Shop), _defineProperty(_QueryParamsProxy$set, routeParamConstants.PARAM_SHOP_TYPE, ShopTypes.COINS), _QueryParamsProxy$set));
      var trigger = Logger.getActionTrigger();
      var eventPayload = {
        balance_before: _this2.props.coin.toString(),
        type: 'regular',
        trigger: trigger || ''
      };
      Logger.sendEvent(EVENT_TYPES.STORE_OPENED, eventPayload);
    };

    return _this2;
  }

  _inherits(OutOfCoin, _Component);

  return _createClass(OutOfCoin, [{
    key: "_getSKUBasedOnPlatform",
    value: function _getSKUBasedOnPlatform(outOfCoinsOffer) {
      if (Utils.getPlatform() === 'ios') {
        return outOfCoinsOffer.MOBILE_PRODUCT_IAP_ID_IOS;
      }

      if (Utils.getPlatform() === 'android') {
        return outOfCoinsOffer.MOBILE_PRODUCT_IAP_ID_ANDROID;
      }

      return outOfCoinsOffer.CURRENCY_ITEM_ID;
    }
  }, {
    key: "render",
    value: function render() {
      var outOfCoinsOffer = this.props.outOfCoinsOffer;
      var quickBuyOfferDetails = {
        title: getText(TEXT_KEY.QUICK_BUY),
        coinAmount: format(outOfCoinsOffer.AMOUNT),
        plusIcon: '+',
        loyaltyAmount: format(outOfCoinsOffer.BONUS_LOYALTY_AMOUNT),
        totalAmount: "".concat(getText(TEXT_KEY.CURRENCY_SIGN)).concat(outOfCoinsOffer.PRICE)
      };
      return this.props.render({
        quickBuyOfferDetails: quickBuyOfferDetails,
        quickBuyHandler: this._quickBuyHandler,
        visitStoreHandler: this._visitStoreHandler
      });
    }
  }]);
}(Component);

export { OutOfCoin as default };